import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
} from '@angular/core';

@Component({
    selector: 'label-skill',
    templateUrl: './label.component.html',
    styleUrls: ['./label.component.scss'],
})
export class LabelSkillComponent implements OnInit, OnChanges {
    @Input() skills;
    @Input() editable = false;
    @Input() mustDisplayGiven = false;
    @Input() mustDisplayFollowed = false;
    @Input() mustDisplayWished = false;
    @Input() mustDisplayCan = false;
    @Input() mustDisplayRefuse = false;

    @Output() deleteSkill = new EventEmitter();

    givenSkills: Array<any>;
    followedSkills: Array<any>;
    wishedSkills: Array<any>;
    canSkills: Array<any>;
    refuseSkills: Array<any>;

    constructor() {}

    ngOnInit(): void {
        this.initComponent();
    }

    ngOnChanges(): void {
        this.initComponent();
    }

    initComponent(): void {
        this.givenSkills = [];
        this.followedSkills = [];
        this.wishedSkills = [];
        this.canSkills = [];
        if (this.mustDisplayGiven) {
            this.givenSkills = this.getGivenSkills(this.skills);
        }
        if (this.mustDisplayFollowed) {
            this.followedSkills = this.getFollowedSkills(this.skills);
        }
        if (this.mustDisplayWished) {
            this.wishedSkills = this.getWishedSkills(this.skills);
        }
        if (this.mustDisplayCan) {
            this.canSkills = this.getCanSkills(this.skills);
        }
        if (this.mustDisplayRefuse) {
            this.refuseSkills = this.getRefuseSkills(this.skills);
        }
    }

    deleteWishedSkill(item) {
        const i = this.wishedSkills.indexOf(item);
        if (i !== -1) {
            this.wishedSkills.splice(i, 1);
            item.wished = false;
            this.deleteSkill.emit(item);
        }
    }

    deleteCanSkill(item) {
        const i = this.canSkills.indexOf(item);
        if (i !== -1) {
            this.canSkills.splice(i, 1);
            item.can = false;
            this.deleteSkill.emit(item);
        }
    }

    deleteRefuseSkill(item) {
        const i = this.refuseSkills.indexOf(item);
        if (i !== -1) {
            this.refuseSkills.splice(i, 1);
            item.refuse = false;
            this.deleteSkill.emit(item);
        }
    }

    getFollowedSkills(skills) {
        let followedSkills = [];
        skills.map((skill) => {
            if (skill.followed && !this.mustDisplayGiven) {
                followedSkills.push(skill);
            } else if (
                skill.followed &&
                followedSkills.indexOf(skill.trainingName) === -1 &&
                this.givenSkills.indexOf(skill.trainingName) === -1
            ) {
                followedSkills.push(skill);
            }
        });
        return followedSkills;
    }

    getWishedSkills(skills) {
        let wishedSkills = [];
        skills.map((skill) => {
            if (skill.wished && !this.mustDisplayFollowed) {
                wishedSkills.push(skill);
            } else if (
                skill.wished &&
                wishedSkills.indexOf(skill.trainingName) === -1 &&
                this.followedSkills.indexOf(skill.trainingName) === -1
            ) {
                wishedSkills.push(skill);
            }
        });
        return wishedSkills;
    }

    getGivenSkills(skills) {
        let givenSkills = [];
        skills.map((skill) => {
            if (
                skill.nbGiven > 0 &&
                givenSkills.indexOf(skill.trainingName) === -1
            ) {
                givenSkills.push(skill);
            }
        });
        return givenSkills;
    }

    private getCanSkills(skills: any) {
        let canSkills = [];
        skills.map((skill) => {
            if (skill.can) {
                canSkills.push(skill);
            }
        });
        return canSkills;
    }

    private getRefuseSkills(skills: any) {
        let refuseSkills = [];
        skills.map((skill) => {
            if (skill.refuse) {
                refuseSkills.push(skill);
            }
        });
        return refuseSkills;
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/_shared/label/label.component.ts